import axios from "axios";
import qs from "qs";
import config from "../../config"

// Base URL of the API

// moved the configuration of api url to config
// search plugin picks up url from axios defaults 
axios.defaults.baseURL = config.api.baseURL

export default {
  login({
    commit,
    dispatch
  }, credentials) {
    // Authenticate a user
    return axios
      .post("/user/login", credentials, {
        withCredentials: true
      })
      .then(response => {
        commit("SET_USER", {
          user: response.data
        });
        commit("SET_USERNAME", {
          username: response.data.login
        });
        return response;
      })
      .catch(error => {
        console.info(error.response.data);
      });
  },
  requestResetPassword({
    commit,
    dispatch
  }, credentials) {
    // Send a reset password request
    return axios
      .get("/user/requestReset?email=" + credentials)
      .then(response => {
        return response;
      })
      .catch(error => {
        console.info(error);
      });
  },
  loginWithGoogle({
    commit,
    dispatch
  }, credentials) {
    return axios({
        method: "post",
        url: "/user/googleLogin",
        data: qs.stringify({
          idtoken: credentials.idtoken
        }),
        withCredentials: true,
        headers: {
          "content-type": "application/x-www-form-urlencoded"
        }
      })
      .then(response => {
        commit("SET_USER", {
          user: response.data
        });
        commit("SET_USERNAME", {
          username: response.data.login
        });
        return response;
      })
      .catch(error => {
        console.info(error);
      });
  },
  checkPassword({
    commit,
    dispatch
  }, credentials) {
    // Authenticate a user
    return axios
      .post("/user/login", credentials, {
        withCredentials: true
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.info(error);
      });
  },
  logout({
    commit
  }) {
    // Logout a user
    return axios
      .post("/user/logout", null, {
        withCredentials: true
      })
      .then(response => {
        commit("CLEAR_USER");
        commit("CLEAR_USERNAME");
      })
      .catch(error => {
        console.info(error);
        commit("CLEAR_USER"); // fixme: trick here - if logout fail, at least remove the user from the state
        commit("CLEAR_USERNAME");
      });
  },
  signup({
    commit,
    dispatch
  }, payload) {
    // Create a new user account
    const headers = {
      "Content-Type": "application/json"
    };
    return axios
      .post("/user", payload, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.info(error.response.data);
      });
  },
  getUser({
    commit
  }, queryParams) {
    // Fetch the information of the logged in user
    return axios
      .get("/user", {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getRecipesList({
    commit
  }, queryParams) {
    // Fetch a list of recipes, paginated
    let url =
      "/recipe/list?status=" +
      queryParams.status +
      "&start=" +
      queryParams.start +
      "&count=" +
      queryParams.count;
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  createRecipe({
    commit,
    dispatch
  }, RecipeData) {
    const headers = {
      "Content-Type": "application/json"
    };
    return axios
      .post("/recipe", RecipeData, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        console.log("success");
        return response.data;
      })
      .catch(error => {
        console.log(error);
      });
  },
  getRecipeEntity({
    commit
  }, pk) {
    // Fetch the recipe entity by id
    let url = "/recipe/" + pk;
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getRecipeRatingUser({
    commit
  }, params) {
    let url = "rating?recipeId=" + params.recipeId + "&userId=" + params.userId;
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getResourceRatingUser({
    commit
  }, params) {
    let url =
      "rating?resourceId=" + params.resourceId + "&userId=" + params.userId;
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  createResource({
    commit,
    dispatch
  }, ResourceData) {
    // register a new resource
    const headers = {
      "Content-Type": "application/json"
    };
    return axios
      .post("/resource", ResourceData, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log(error);
      });
  },
  deleteRecipeRating({
    commit,
    dispatch
  }, pk) {
    // register a new recipe rating
    const headers = {
      "Content-Type": "application/json"
    };
    return axios
      .delete("/rating?recipeId=" + pk, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.info(error);
      });
  },
  deleteResourceRating({
    commit,
    dispatch
  }, pk) {
    // register a new recipe rating
    const headers = {
      "Content-Type": "application/json"
    };
    return axios
      .delete("/rating?resourceId=" + pk, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        console.log(response);
      })
      .catch(() => {
        // console.info(error)
      });
  },
  submitRecipeRating({
    commit,
    dispatch
  }, ratingObj) {
    const headers = {
      "Content-Type": "application/json"
    };
    return axios
      .post(
        "/rating?recipeId=" +
        ratingObj.recipeId +
        "&stars=" +
        ratingObj.stars +
        "&comment=" +
        ratingObj.comment,
        ratingObj, {
          withCredentials: true,
          headers: headers
        }
      )
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  submitResourceRating({
    commit,
    dispatch
  }, ratingObj) {
    const headers = {
      "Content-Type": "application/json"
    };
    return axios
      .post(
        "/rating?resourceId=" +
        ratingObj.recipeId +
        "&stars=" +
        ratingObj.stars +
        "&comment=" +
        ratingObj.comment,
        ratingObj, {
          withCredentials: true,
          headers: headers
        }
      )
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getRecipeCurrentRatings({
    commit
  }, queryParams) {
    // Fetch a list of current recipe ratings paginated
    let url =
      "/rating?recipeId=" +
      queryParams.id +
      "&start=" +
      queryParams.start +
      "&count=" +
      queryParams.count;
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        console.log(response);
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getResourceCurrentRatings({
    commit
  }, queryParams) {
    // Fetch a list of current recipe ratings paginated
    let url =
      "/rating?resourceId=" +
      queryParams.id +
      "&start=" +
      queryParams.start +
      "&count=" +
      queryParams.count;
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        console.log(response);
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  uploadResourceContent({
    commit,
    dispatch
  }, params) {
    // upload the content of an existing resource
    let url = "/resource/" + params.id;
    const headers = {
      "Content-Type": "multipart/form-data"
    };
    return axios
      .post(url, params.file, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log(error);
      });
  },
  uploadRecipeBanner({
    commit,
    dispatch
  }, params) {
    // Upload the recipe banner
    let url = "/recipe/image/" + params.id;
    const headers = {
      "Content-Type": "multipart/form-data"
    };
    return axios
      .post(url, params.file, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log(error);
      });
  },
  uploadOrganisationBanner({
    commit,
    dispatch
  }, params) {
    // Upload the recipe banner
    let url = "/organisation/image/" + params.id;
    const headers = {
      "Content-Type": "multipart/form-data"
    };
    return axios
      .post(url, params.file, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log(error);
      });
  },
  createCollaborator({
    commit,
    dispatch
  }, ResourceData) {
    const headers = {
      "Content-Type": "application/json"
    };
    return axios
      .post("/organisation", ResourceData, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        console.log(response);
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  deleteRecipeEntity({
    commit
  }, pk) {
    // Delete an existing recipe
    const headers = {
      "Content-Type": "application/json"
    };
    return axios
      .delete("/recipe/" + pk, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        return response;
      })
      .catch(() => {
        // console.info(error)
      });
  },
  getResourcesList({
    commit
  }, queryParams) {
    // Fetch a list of resources, paginated
    let url =
      "/resource/list?status=" +
      queryParams.status +
      "&start=" +
      queryParams.start +
      "&count=" +
      queryParams.count;
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getResourceEntity({
    commit
  }, pk) {
    // Fetch the resource entity by id
    let url = "/resource/" + pk + "?content=false";
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getResourceContent({
    commit
  }, pk) {
    // Fetch the resource content by id
    let url = "/resource/" + pk + "?content=true";
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  deleteResourceEntity({
    commit
  }, pk) {
    // Delete an existing resource
    return axios
      .delete("/resource/" + pk + "?force=false", {
        withCredentials: true
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getOrganizationEntity({
    commit
  }, organizationId) {
    // Fetch the organisation entity by id
    return axios
      .get("/organisation/" + organizationId, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getOrganizationList({
    commit
  }, queryParams) {
    // Fetch a list of organizations, paginated
    let url =
      "/organisation/list?status=" +
      queryParams.status +
      "&start=" +
      queryParams.start +
      "&count=" +
      queryParams.count;
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  deleteOrganizationEntity({
    commit
  }, pk) {
    // Delete an existing organization
    return axios
      .delete("/organisation/" + pk, {
        withCredentials: true
      })
      .then(response => {
        return response;
      })
      .catch(() => {
        // console.info(error)
      });
  },
  getGroupEntity({
    commit
  }, groupId) {
    // Fetch the group entity by id
    return axios
      .get("/group/" + groupId, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getGroupEntityByName({
    commit
  }, groupName) {
    // Fetch the group entity by name
    axios
      .get("/group/byName?name=" + groupName, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getGroupMembers({
    commit
  }, queryParams) {
    // Fetch the group members
    let url =
      "/group/" +
      queryParams.groupId +
      "/members?start=" +
      queryParams.start +
      "&count=" +
      queryParams.count +
      "&includeUnconfirmed=" +
      queryParams.includeUnconfirmed;
    axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  deleteGroup({
    commit
  }, pk) {
    return axios
      .delete(
        "/group/" +
        pk , {
          withCredentials: true
        }
      )
      
      .catch(error => {
        console.info(error);
        location.reload();
      });
  },
  getGroupsUser({
    commit
  }) {
    // Fetch the groups the logged in user is part of
    let url = "/user";
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  leaveGroup({
    commit
  }, groupId) {
    // User leaves the selected group
    let url = "/group/memberRejectGroup/" + groupId;
    return axios
      .post(url, null, {
        withCredentials: true
      })
      .then(response => {
        console.log("leave");
        console.log(respone);
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  },
  getOwnGroups({
    commit
  } , queryParams ) {
    let url = "/group/list?status=OWN&start="+queryParams.start+"&count="+queryParams.count;
 
    return axios
      .get(url, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  }
  ,
  cloneRecipe({
    commit
  }, recipeId) {
    let url = "/recipe/clone/" + recipeId;
    return axios
      .post(url, null, {
        withCredentials: true
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.info(error);
      });
  },
  bookmarkRecipe({
    commit
  }, recipeId) {
    let url = "/bookmark/recipe/" + recipeId;
    return axios
      .post(url, null, {
        withCredentials: true
      })
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => console.info(error));
  },
  bookmarkResource({
    commit
  }, resourceId) {
    let url = "/bookmark/resource/" + resourceId;
    return axios
      .post(url, null, {
        withCredentials: true
      })
      .then(response => {
        return response;
      })
      .catch(error => console.info(error));
  },
  deleteBookmarkRecipe({
    commit
  }, recipeId) {
    const headers = {
      "Content-Type": "application/json"
    };
    let url = "/bookmark/recipe/" + recipeId;
    return axios
      .delete(url, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        return response;
      })
      .catch(error => console.info(error));
  },
  deleteBookmarkResource({
    commit
  }, resourceId) {
    const headers = {
      "Content-Type": "application/json"
    };
    let url = "/bookmark/resource/" + resourceId;
    return axios
      .delete(url, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        return response;
      })
      .catch(error => console.info(error));
  },
  loadNotifications({
    commit
  }, payload) {
    console.log("response.data");
    const headers = {
      "Content-Type": "application/json"
    };
    let url = "/notification";
    if( payload.notificationsCount ) {
      url +=  "?start=" +
      payload.notificationsStart +
      "&count=" +
      payload.notificationsCount;
    }

    return axios
      .get(url, {
        withCredentials: true,
        headers: headers
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.info(error);
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js